import React from 'react';
import styles from './ui.module.css';

/**
 * A code, symbol or classification shown in a cell — data, not state. Use
 * <Pill> when the thing being shown is a status.
 */
const Tag: React.FC<{ children: React.ReactNode; title?: string }> = ({ children, title }) => (
  <span className={styles.tag} title={title}>{children}</span>
);

export default Tag;
